var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiringWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.84513 9.5H1.15487C0.266229 9.5 -0.287731 8.61627 0.156591 7.91247L4.50172 1.02786C4.94604 0.324048 6.05396 0.324048 6.49828 1.02786L10.8434 7.91247C11.2877 8.61627 10.7338 9.5 9.84513 9.5ZM5.5 5.79575C5.81737 5.79575 6.07704 5.55762 6.07704 5.26657V4.20822C6.07704 3.91717 5.81737 3.67904 5.5 3.67904C5.18263 3.67904 4.92296 3.91717 4.92296 4.20822V5.26657C4.92296 5.55762 5.18263 5.79575 5.5 5.79575ZM4.92296 7.91247H6.07704V6.85411H4.92296V7.91247Z",
    fill: "#FF640D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiringWarning);
export default __webpack_public_path__ + "static/media/expiring-warning.20b8f3eb8af1a0d26b4285e92b95d940.svg";
export { ForwardRef as ReactComponent };